import { CREATE_WHATSAPP_PLAN, GET_WHATSAPP_PLAN, WHATSAPP_PLAN_REQUEST, DELETE_WHATSAPP_PLAN, UPDATE_WHATSAPP_PLAN, WHATSAPP_PLAN_REQUEST_FAILURE } from "../types";

const initialState = {
  whatsappPlan: [],
  loading: false,
  error: null,
};

const whatsappPlanReducer = (state = initialState, action) => {
  switch (action.type) {
    case WHATSAPP_PLAN_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_WHATSAPP_PLAN: {
      return {
        ...state,
        whatsappPlan: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_WHATSAPP_PLAN:
      console.log('<<action---', action.payload)
      return {
        ...state,
        whatsappPlan: [action.payload, ...state.whatsappPlan],
        loading: false,
        error: null
      };
    case UPDATE_WHATSAPP_PLAN:
      const whatsappPlanData = state.whatsappPlan.slice(0);
      const uIndex = whatsappPlanData.findIndex((data) => data.id === action.payload.id);
      whatsappPlanData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        whatsappPlan: [ ...whatsappPlanData ],
        loading: false,
        error: null
      };
    case DELETE_WHATSAPP_PLAN:
      const whatsappPlan = state.whatsappPlan?.slice(0);
      const index = whatsappPlan.findIndex((data) => data.id === action.id);
      if (index > -1) {
          whatsappPlan.splice(index, 1);
      }
      return {
        ...state,
        whatsappPlan: [...whatsappPlan],
        loading: false,
        error: null
      }
    case WHATSAPP_PLAN_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default whatsappPlanReducer;